import { Injectable, ValueProvider, inject } from '@angular/core';
import { BREAKPOINTS, MediaChange, MediaObserver } from '@angular/flex-layout';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';
import { Breakpoints } from './media-observer.types';

type MediaMatchesMap = Record<string, MediaChange>;

export const breakPointsProvider = {
  provide: BREAKPOINTS,
  useValue: [
    {
      matches: true,
      mediaQuery: 'screen and (max-width: 1199px)',
      mqAlias: 'l',
      property: '',
      suffix: Breakpoints.L
    },
    {
      matches: true,
      mediaQuery: 'screen and (min-width: 1200px) and (max-width: 1399px)',
      mqAlias: 'xl',
      property: '',
      suffix: Breakpoints.XL
    },
    {
      matches: true,
      mediaQuery: 'screen and (min-width: 1400px)',
      mqAlias: 'xxl',
      property: '',
      suffix: Breakpoints.XXL
    }
  ]
};

export function provideCustomBreakpointsProvider(): ValueProvider {
  return breakPointsProvider;
}

@Injectable()
export class MediaObserverService {
  private readonly mediaObserver = inject(MediaObserver);

  private readonly matches$: Observable<MediaMatchesMap> = this.mediaObserver.asObservable().pipe(
    map((change: MediaChange[]) =>
      change.reduce((acc, change: MediaChange) => {
        return {
          ...acc,
          [change.suffix]: change
        };
      }, {} as MediaMatchesMap)
    ),
    distinctUntilChanged(),
    shareReplay(1)
  );

  asObservable(): Observable<MediaMatchesMap> {
    return this.matches$;
  }
}
